import React, { useState, useEffect } from "react";
import label from "../../../image/lebal-footer.jpg";
import "./Footer.css";
import { Link } from "react-router-dom";
import SalaryTapApk from "../../../apk/Salarytp.apk";

import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";

import instagram from "../../../image/instagram.png";
import { APIURL, APIURLCOT } from "../../../Config";
import axios from "axios";
function Footer() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [width, setWidth] = React.useState(window.innerWidth);
  const [show, setShow] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [callNow, setCallNow] = useState(false);

  const toggleItem = (index) => {
    console.log("index", index);
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  const handleDownload = () => {
    const screenWidth = window.innerWidth;

    if (screenWidth < 700) {
      // If width is less than 700, navigate to the download page
      navigate("/salarytap/downloadpage");
    } else {
      // Otherwise, download the APK file directly
      const link = document.createElement("a");
      link.href = SalaryTapApk;
      link.download = "Salarytap.apk"; // Optional: Set the file name
      link.click();
    }
  };

  const initialValues = {
    name: "",
    contact: "",
    email: "",
    organisation: "",
    teamSize: "",
    message: "",
    recaptcha: false,
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Required"),
    contact: Yup.string()
      .required("Required")
      .matches(/^[0-9]{10}$/, "Must be 10 digits"),
    email: Yup.string().email("Invalid email").required("Required"),
    organisation: Yup.string().required("Required"),
    teamSize: Yup.string().required("Required"),
    message: Yup.string(),
  });
  const handleClose = () => {
    setShow(false);
  };

  const handleSubmit = async (values, { resetForm }) => {
    const payload = {
      // or generate dynamically if needed
      name: values.name,
      mobileno: values.contact,
      emailid: values.email,
      organizationName: values.organisation,
      teamSize: parseInt(values.teamSize),
      message: values.message,
      entrydate: new Date().toISOString().split("T")[0], // "YYYY-MM-DD"
      entryby: "System",
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${APIURL}/demoreports`,
      headers: {
        "Content-Type": "application/json",
        Cookie: "JSESSIONID=CF96D4659F070D96787CCFCF71A133A1",
      },
      data: payload,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        resetForm();
        setFormSubmitted(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const faq = [
    {
      question:
        "What is Salarytap and how does it work for employers and employees?",
      answer:
        "Salarytap is a platform that allows employees to access their salary on demand. Employers can upload their employee data to the Salarytap workspace and set a maximum withdrawal limit for each employee. Once the setup is complete, employees can immediately access funds through the <a href='https://shorturl.at/93EjL' style='color: blue;'>Salarytap app</a>, available on the Google Play Store. Employees can withdraw funds 24/7.",
    },
    {
      question: "How do employers set up their workspace on Salarytap?",
      answer: `
      Salarytap is a platform that allows employees to access their salary on demand. Employers can upload their employee data to the Salarytap workspace and set a maximum withdrawal limit for each employee. Once the setup is complete, employees can immediately access funds through the Salarytap app, available on Google Play Store. Employees can withdraw funds instantly.
      `,
    },
    {
      question:
        "Can employers customise Salarytap in their HR App or use their own funds for advancing salary to their employees?",
      answer:
        "Salarytap can be customised to integrate with the employer’s HR app, and if employers prefer to use their own funds for advancing salary, they can integrate their bank account to fund their employees",
    },
    {
      question: "What will it cost the employees?",
      answer: `Employees incur a one-time setup fee of Rs. 300 at the time of their first withdrawal.<br/>
         There is no interest charged, but a flat convenience fee is applied to each withdrawal. `,
    },
    {
      question: "What is the cost of custom integration?",
      answer:
        "Integrating Salarytap into the employer's HR app or choosing to use the employer's funds to facilitate employee funding will cost approximately Rs. 3 to 5 lakhs for each integration.",
    },
    {
      question:
        "What are the steps for employers to enable their employees to withdraw funds?",
      answer:
        "First, you'll need to create your 'Workspace.' After completing your 'Profile,' your workspace will be set up. Once the backend is configured, we'll notify you. At that point, you can upload your employee list, and your employees will be able to start withdrawing funds immediately.",
    },
  ];

  return (
    <div>
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{formSubmitted ? "" : "Book a Demo"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {formSubmitted ? (
            <div className="text-center py-5">
              {callNow ? (
                <>
                  {" "}
                  <a
                    href="tel:+918146592004"
                    className="btn btn-primary"
                    style={{
                      backgroundColor: "#007bff",
                      border: "none",
                      color: "white",
                      textAlign: "center",
                      padding: "10px 20px",
                      borderRadius: "5px",
                      textDecoration: "none",
                    }}
                  >
                    Call Now
                  </a>{" "}
                  <Button
                    variant="secondary"
                    onClick={() => handleClose()}
                    style={{ marginTop: "10px", width: "100px" }}
                  >
                    OK
                  </Button>
                </>
              ) : (
                <>
                  <h4 className="text-success mb-3">
                    Thank you for your interest. Our executive will call you
                    shortly.
                  </h4>
                  <div className="card">
                    <p className="mb-4">
                      If you would like to speak to someone you may call{" "}
                      <b>8146592004</b>
                    </p>
                    <div className="d-flex align-items-center justify-content-center">
                      <Button
                        variant="secondary"
                        onClick={() => setCallNow(true)}
                        style={{ marginTop: "10px", width: "100px" }}
                      >
                        Yes
                      </Button>
                      <Button
                        variant="secondary"
                        onClick={() => handleClose()}
                        className="ml-2"
                        style={{ marginTop: "10px", width: "100px" }}
                      >
                        No
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </div>
          ) : (
            <>
              {" "}
              {/* <h6
                  className="mb-4"
                  style={{ fontWeight: "500", fontSize: "16px" }}
                >
                  Salarytap is a seamless, fully automated process that allows
                  employees to access their salary in advance as soon as the
                  employer finishes setting up the workspace. Employers simply
                  need to create a workspace, fill in a few details, and upload
                  employee data to provide on-demand salary access to their
                  employees. Kindly find some questions and answers intended to
                  offer deeper insight into the product.
                </h6>
                {faq.map((item, index) => (
                  <div
                    key={index}
                    className="border px-3 py-2 mb-2 rounded-lg"
                    onClick={() => toggleItem(index)}
                    style={{ cursor: "pointer" }}
                  >
                    <div
                      className={`d-flex align-items-center justify-content-between ${
                        openIndex === index
                          ? "border-bottom border-secondary pb-2"
                          : ""
                      }`}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <div
                          style={{
                            color: openIndex === index ? "#66a725" : "#000",
                          }}
                          className={`d-flex  font-weight-bold`}
                        >
                          <div className="text-nowrap mr-1">Q.</div>
                          {item.question}
                        </div>
                      </div>
                      <div className="px-2 py-1 rounded">
                        {openIndex === index ? (
                          <i class="fa-solid fa-chevron-up"></i>
                        ) : (
                          <i class="fa-solid fa-chevron-down"></i>
                        )}
                      </div>
                    </div>
                    {openIndex === index && (
                      <div
                        className="pt-2 px-2"
                        style={{ fontSize: "17px" }}
                        dangerouslySetInnerHTML={{ __html: item.answer }}
                      />
                    )}
                  </div>
                ))} */}
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isSubmitting }) => (
                  <Form>
                    <div className="form-group mb-2">
                      <Field
                        className="form-control"
                        name="name"
                        placeholder="Name *"
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="form-group mb-2">
                      <Field
                        className="form-control"
                        name="contact"
                        placeholder="Contact Number *"
                      />
                      <ErrorMessage
                        name="contact"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="form-group mb-2">
                      <Field
                        className="form-control"
                        name="email"
                        placeholder="Email Id *"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="form-group mb-2">
                      <Field
                        className="form-control"
                        name="organisation"
                        placeholder="Organisation Name *"
                      />
                      <ErrorMessage
                        name="organisation"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="form-group mb-2">
                      <Field
                        className="form-control"
                        name="teamSize"
                        placeholder="Team Size *"
                      />
                      <ErrorMessage
                        name="teamSize"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                    {/* 
                    <div className="form-group mb-2">
                      <Field
                        as="textarea"
                        className="form-control"
                        name="message"
                        placeholder="Message"
                      />
                    </div> */}

                    {/* <div className="form-group mb-3">
                    <label className="d-flex align-items-center">
                      <Field type="checkbox" name="recaptcha" />
                      <span className="ms-2">I'm not a robot</span>
                    </label>
                    <ErrorMessage
                      name="recaptcha"
                      component="div"
                      className="text-danger"
                    />
                  </div> */}

                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      <Button
                        type="submit"
                        disabled={isSubmitting}
                        style={{
                          backgroundColor: "#77dd77",
                          border: "none",
                          width: "120px",
                        }}
                      >
                        Submit
                      </Button>
                      {/* 
                        <div style={{ marginTop: "15px" }}>
                          <a
                            href="tel:+918146592004"
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#007bff",
                              border: "none",
                              color: "white",
                              textAlign: "center",
                              padding: "10px 20px",
                              borderRadius: "5px",
                              display: "inline-block",
                              textDecoration: "none",
                            }}
                          >
                            Call Now
                          </a>
                        </div> */}
                    </div>
                  </Form>
                )}
              </Formik>{" "}
            </>
          )}
        </Modal.Body>
      </Modal>
      <Modal
        className=""
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setOpenIndex(null);
        }}
        size="lg"
        style={{ background: "rgb(255 255 255 / 40%)" }}
      >
        <Modal.Header closeButton> </Modal.Header>
        <Modal.Body>
          <h6 className="mb-2" style={{ fontWeight: "500", fontSize: "16px" }}>
            Hi!,
          </h6>
          <h6 className="mb-4" style={{ fontWeight: "500", fontSize: "16px" }}>
            Salarytap is a seamless, fully automated process that allows
            employees to access their salary in advance as soon as the employer
            finishes setting up the workspace. Employers simply need to create a
            workspace, fill in a few details, and upload employee data to
            provide on-demand salary access to their employees. Kindly find some
            questions and answers intended to offer deeper insight into the
            product.
          </h6>

          {faq.map((item, index) => (
            <div
              key={index}
              className="border px-3 py-2 mb-2 rounded-lg"
              onClick={() => toggleItem(index)}
              style={{ cursor: "pointer" }}
            >
              <div
                className={`d-flex align-items-center justify-content-between ${
                  openIndex === index
                    ? "border-bottom border-secondary pb-2"
                    : ""
                }`}
              >
                <div className="d-flex align-items-center gap-2">
                  <div
                    style={{
                      color: openIndex === index ? "#66a725" : "#000",
                    }}
                    className={`d-flex  font-weight-bold`}
                  >
                    <div className="text-nowrap mr-1">Q.</div>
                    {item.question}
                  </div>
                </div>
                <div className="px-2 py-1 rounded">
                  {openIndex === index ? (
                    <i class="fa-solid fa-chevron-up"></i>
                  ) : (
                    <i class="fa-solid fa-chevron-down"></i>
                  )}
                </div>
              </div>
              {openIndex === index && (
                <div
                  className="pt-2 px-2"
                  style={{ fontSize: "17px" }}
                  dangerouslySetInnerHTML={{ __html: item.answer }}
                />
              )}
            </div>
          ))}
        </Modal.Body>
        {/* <Modal.Footer className="d-flex justify-content-end">
                  <button
                    className="btn btn-success"
                    onClick={() => {
                      history("/salarytap/createYourWorkspace");
                    }}
                    style={{ width: "20%", backgroundColor: "#66a725" }}
                  >
                    OK
                  </button>
                </Modal.Footer> */}
      </Modal>
      <div className="container">
        <div className="px-md-5 mt-3">
          <div
            className="row"
            style={{
              backgroundColor: "rgb(239, 239, 239)",
              color: "#fff",
              padding: 4,
              margin: 0,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="col-12 col-md-4 col-lg-4 px-5 d-flex flex-column">
              <button
                className="btns  fw-semibold"
                onClick={() => navigate("/salarytap/about")}
              >
                About
              </button>
              <button
                className="btns  fw-semibold"
                onClick={() => navigate("/salarytap/howItWorks")}
              >
                How it Works
              </button>
              <button
                className="btns text-nowrap fw-semibold"
                onClick={() => navigate("/salarytap/grievance-redressal")}
              >
                Grievance Redressal
              </button>
              <button
                className="btns  fw-semibold"
                onClick={() => navigate("/salarytap/privacy-policy")}
              >
                Privacy policy
              </button>
              <button
                className="btns text-nowrap fw-semibold"
                onClick={() => navigate("/salarytap/term-conditions")}
              >
                Terms and Conditions
              </button>
              <button
                className="btns text-nowrap fw-semibold"
                onClick={() => navigate("/salarytap/media")}
              >
                Media
              </button>
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4 d-flex flex-column">
              <div className="d-flex justify-content-start">
                <button
                  className="btns custom-login text-center"
                  onClick={() => navigate("/salarytap/login")}
                >
                  <b>LOGIN</b>
                </button>
              </div>

              <div className="d-flex justify-content-start">
                <button
                  className="btns mt-2 custom text-center"
                  onClick={() => {
                    setShow(true);
                    setFormSubmitted(false);
                  }}
                >
                  Book a Demo
                </button>
              </div>
              <div className="d-flex justify-content-start">
                <button
                  className="btns mt-2 primary-btn text-center"
                  onClick={() => navigate("/salarytap/createYourWorkspace")}
                >
                  <b> Create your workspace</b>
                </button>
              </div>
              {/* <div className="d-flex justify-content-start">
                <button
                  className="btns mt-2 customdownload text-center"
                  style={{
                    background: "#3F86F7",
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#fff",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                  onClick={handleDownload}
                >
                  Download App <br />
                  <span style={{ fontSize: "14px" }}>(For employees)</span>
                </button>
              </div> */}
            </div>
            <div
              className="col-sm-12 col-md-4 col-lg-4 d-flex flex-column justify-content-start"
              style={{ alignItems: "center" }}
            >
              <div
                style={{
                  fontSize: 44,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <a
                  href="https://www.facebook.com/profile.php?id=61561204493434"
                  target="_blank"
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth={0}
                    viewBox="0 0 16 16"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/salarytap.official/?hl=en"
                  target="_blank"
                >
                  <img src={instagram} width="65px" height="50px" />
                </a>
              </div>
              <div style={{ width: "230px" }}>
                <a href="https://shorturl.at/93EjL" target="_blank">
                  <img
                    src="https://play.google.com/intl/en_us/badges/images/generic/en-play-badge.png"
                    width="100%"
                    height="100%"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
